import { useEffect, useRef } from 'react'

const isEditableTarget = (target: EventTarget | null) => {
  if (!(target instanceof HTMLElement)) return false

  return (
    target.isContentEditable ||
    ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName)
  )
}

/**
 * Atalho de teclado que ignora digitação em campos e modificadores de sistema.
 * `matcher`/`handler` podem vir inline: o listener lê sempre a versão corrente.
 */
export const useHotkey = (
  matcher: (event: KeyboardEvent) => boolean,
  handler: () => void,
  { enabled = true }: { enabled?: boolean } = {}
) => {
  const matcherRef = useRef(matcher)
  const handlerRef = useRef(handler)
  matcherRef.current = matcher
  handlerRef.current = handler

  useEffect(() => {
    if (!enabled) return undefined

    const listener = (event: KeyboardEvent) => {
      if (event.metaKey || event.ctrlKey || event.altKey) return
      if (isEditableTarget(event.target)) return
      if (!matcherRef.current(event)) return

      event.preventDefault()
      handlerRef.current()
    }

    document.addEventListener('keydown', listener)

    return () => document.removeEventListener('keydown', listener)
  }, [enabled])
}
